import assetPath from '/opt/actions-runner/_work/crate/crate/xinglets/startpage-logged-out/entry/src/search-inspiration-section/assets/inspire.jpg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')